import { Lock } from "lucide-react";
import { Field, TextArea, Choice, StepTitle, TextInput } from "@/components/register/Fields";

const F = [
  ["conditions", "Existing medical conditions"],
  ["medications", "Medications"],
  ["injuries", "Current or recent injuries"],
  ["severe_allergies", "Severe allergies"],
  ["additional", "Any other relevant medical information"],
];

export const StepMedical = ({ player, setMedical }) => {
  const m = player.medical;
  return (
    <div data-testid="step-medical">
      <StepTitle eyebrow={`${player.first_name || "Player"} · Step 4`} title="Medical details" sub="Relevant medical conditions, allergies and injuries. Leave blank if not applicable." />
      <p className="mb-6 flex gap-2 items-start text-xs text-slate-400"><Lock size={14} className="accent-text shrink-0 mt-0.5" />Medical information is encrypted and only visible to authorised staff.</p>
      <div className="space-y-5">
        <Field label="Asthma">
          <Choice testid="medical-asthma" value={m.asthma} onChange={(v) => setMedical("asthma", v)} options={[{ value: false, label: "No" }, { value: true, label: "Yes" }]} />
        </Field>
        {m.asthma && (
          <Field label="Asthma details (inhaler, triggers)">
            <TextInput testid="medical-asthma-details" value={m.asthma_details} onChange={(e) => setMedical("asthma_details", e.target.value)} />
          </Field>
        )}
        {F.map(([k, label]) => (
          <Field key={k} label={label}>
            <TextArea testid={`medical-${k.replace(/_/g, "-")}`} value={m[k]} onChange={(e) => setMedical(k, e.target.value)} />
          </Field>
        ))}
      </div>
    </div>
  );
};
